<script>
    import PeriodComponentMixin from '@/components/inline-time-period/period-component-mixin';

    export default {
        name: 'immediately',
        functional: true,
        mixins: [PeriodComponentMixin],
        render(h) {
            return h('span');
        },
    };
</script>
